// React Third-Party Libraries
import { Form, message } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

// Constants Library

// Components Library
import DrawerBilling from "../DrawerBilling";

// Services Library

// Redux Actions
import * as REDUX_ACTION from "../../../../services/redux/actions";

export const DrawerBill = (props) => {
  const { isOpen, setIsOpen, data, user, type } = props;
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [fileList, setFileList] = useState([]);

  const role = user?.uroleid;

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(data);
    }
  }, [isOpen]);

  useEffect(() => {
    if (fileList.length > 0) {
      if (type === "pay") {
        form.setFieldValue("receipt", fileList);
      }
    }
  }, [fileList, type]);

  const handlePay = () => {
    form
      .validateFields()
      .then(() => {

        const receiptFilter = fileList.map(({ uid, status, ...rest }) => rest);

        const dataItems = {
          ...data,
          receipt: receiptFilter,
          status: 3,
        };

        delete dataItems.key;
        delete dataItems.refid;
        delete dataItems.company_name;

        const formData = {
          billid: data.billid,
          updatedBy: user.memid,
          items: dataItems,
        };

        messageApi.open({
          type: "loading",
          content: "Paying the bill...",
          duration: 0,
        });

        dispatch(
          REDUX_ACTION.v1_billing.payback_billing_request(
            formData,
            role,
            () => {
              messageApi.destroy();
            }
          )
        );
      })
      .catch((error) => {
        message.error("fill the form");
      });
  };

  return (
    <>
      {contextHolder}
      <DrawerBilling
        form={form}
        data={data}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        handleSave={handlePay}
        type={type}
        fileList={fileList}
        setFileList={setFileList}
      />
    </>
  );
};